export default __webpack_public_path__ + "static/media/logo.ddce55e5.png";